import { useContext } from 'react'
import ActiveNavbarContext from '../context/ActiveNavbarProvider';

const useActiveNavbar = () => {
    return useContext(ActiveNavbarContext);
}

export default useActiveNavbar